import React, { Component } from 'react';
import utils from '../../common/services/utils';
import { Link } from 'react-router-dom';
import { Glyphicon, Image } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';

class Timeline extends Component {
	render() {
		const { data, schoolYears, grades, t } = this.props;
		const schoolYearGroups = utils.groupBy(data, 'schoolYearId');

		return <div className='timeline'>
			<div className='spine' />
			{Object.keys(schoolYearGroups).sort((a, b) => a.id > b.id ? 1 : -1).map(key => {
				const schoolYear = schoolYears.find(x => x.id === Number(key));
				const enrolmentsInSchoolYear = schoolYearGroups[key].sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? -1 : 1);
				return <div key={key}>
					<div className='date_separator'>
						<span>{schoolYear ? schoolYear.name : key}</span>
					</div>
					<ul className='columns'>
						{enrolmentsInSchoolYear.map(x => {
							const grade = grades[x.grade.id];
							return <li key={x.id}>
								<div className='timeline_element teal' style={{ minWidth: '300px' }}>
									<div className='timeline_title'>
										<span className='timeline_label'>
											{x.name || (grade && grade.name)}
										</span>
										<span className='timeline_date'>{x.term.name}</span>
									</div>
									<div className='content'>
										<div style={{ float: 'left', width: '30%', marginTop: '3px' }}>{grade && grade.pictureUrl && <Image width={64} height={64} thumbnail src={grade.pictureUrl} alt={grade.name} style={{ marginRight: '5px' }} />}</div>
										<div style={{ float: 'left', width: '70%' }}>
											<div>{x.description}</div>
											<div><Glyphicon glyph='map-marker' /> {x.center}</div>
											<div><Glyphicon glyph='calendar' /> {ui.formatDate(x.startDate)}</div>
											<div><Glyphicon glyph='stats' /> {t('Common_Lessons_Count', { count: x.remainingQuantity })}</div>
										</div>
										<div className='clearfix' />
									</div>
									<div className='readmore'>
										<Link to={`/enrolments/${x.id}`} className='btn btn-info'>{t('Common_View')} <FontAwesomeIcon icon={faArrowCircleRight} /></Link>
									</div>
								</div>
							</li>;
						})}
					</ul>
				</div>;
			})}
		</div>;
	}
}

export default withTranslation()(Timeline);